import { render, staticRenderFns } from "./RadialClock.vue?vue&type=template&id=dc8036b8&lang=pug&"
import script from "./RadialClock.vue?vue&type=script&lang=js&"
export * from "./RadialClock.vue?vue&type=script&lang=js&"
import style0 from "./RadialClock.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports